import React from 'react';
import { CreditCardDisplay } from 'src/components/selfService/common/Balance/components/CreditCardDisplay/CreditCardDisplay';
import { BankAccountDisplay } from 'src/components/selfService/common/Balance/components/BankAccountDisplay/BankAccountDisplay';
import { PaymentMethodItem } from 'src/components/selfService/common/Balance/utils/paymentMethodUtils/getSortedPaymentMethods';
import { PaymentMethodType } from 'src/types/Balance';

export interface PaymentMethodItemDisplayProps {
  method: PaymentMethodItem;
  showDefaultBadge?: boolean;
  showBorder?: boolean;
}

export function PaymentMethodItemDisplay({
  method,
  showDefaultBadge = true,
  showBorder = true,
}: PaymentMethodItemDisplayProps): JSX.Element {
  const isDefault = showDefaultBadge && method.item.isDefault;

  if (method.type === PaymentMethodType.CARD) {
    const { brand, expirationMonth, expirationYear, lastFourDigits } =
      method.item;
    return (
      <CreditCardDisplay
        brand={brand}
        expiration={{ month: expirationMonth, year: expirationYear }}
        lastFourDigits={lastFourDigits}
        isDefault={isDefault}
        showBorder={showBorder}
      />
    );
  }

  const { institutionName, accountName, accountNumberMask } = method.item;
  return (
    <BankAccountDisplay
      institutionName={institutionName}
      accountName={accountName}
      accountNumberMask={accountNumberMask}
      isDefault={isDefault}
      showBorder={showBorder}
    />
  );
}
